module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "sidebar",
    class: {
      'sidebar--floating': _vm.isFloating
    },
    style: ({
      'padding-top': _vm.offsetTop + 'px'
    })
  }, [(_vm.isLoading) ? _c('loading', {
    attrs: {
      "alt": true
    }
  }) : [_c('sidebar-header', {
    attrs: {
      "user": _vm.user,
      "disableMenu": _vm.disableUserMenu
    }
  }), (_vm.showOptions) ? _c('div', {
    staticClass: "sidebar__options"
  }, [(_vm.backLink) ? _c('h2', {
    staticClass: "sidebar__tag",
    class: {
      'sidebar__tag--rounded': _vm.isFloating
    }
  }, [_c('router-link', {
    staticClass: "sidebar__back button-backward button-backward-primary",
    attrs: {
      "to": _vm.backLink
    }
  }, [_vm._v(_vm._s(_vm.backLinkTitle))]), (_vm.collectionName) ? _c('router-link', {
    staticClass: "sidebar__name",
    class: {
      'is-active': _vm.isCollectionActive
    },
    attrs: {
      "to": _vm.collectionLink
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        if (!$event.metaKey) { return null; }
        _vm.$emit('viewCollectionInfo')
      }
    }
  }, [(_vm.collectionPrefix) ? _c('span', {
    staticClass: "mini-hidden"
  }, [_vm._v(_vm._s(_vm.collectionPrefix))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.collectionNameExcerpt) + "\n                ")]) : _vm._e()], 1) : _vm._e(), (_vm.addLink) ? _c('h2', {
    staticClass: "sidebar__tag sidebar__tag--inverted sidebar__tag--multi",
    class: {
      'sidebar__tag--rounded': _vm.isFloating
    }
  }, [_c('router-link', {
    staticClass: "sidebar__add-new",
    attrs: {
      "to": _vm.addLink
    }
  }, [_c('span', {
    staticClass: "icon icon--add icon--inline"
  }), _vm._v(" Nieuw")])], 1) : _vm._e(), _vm._t("options")], 2) : _vm._e(), _c('div', {
    directives: [{
      name: "scroller",
      rawName: "v-scroller"
    }],
    staticClass: "sidebar__content scrollable",
    attrs: {
      "id": "sidebar-content"
    }
  }, [_vm._t("default", [(!_vm.isFloating) ? _c('timeline', {
    attrs: {
      "items": _vm.items,
      "isActive": _vm.isActive,
      "collectionName": _vm.collectionName
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._t("item", null, null, props)]
      }
    }])
  }) : _vm._e()])], 2), _c('div', {
    staticClass: "sidebar__copyright"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showDisclaimer($event)
      }
    }
  }, [_vm._v("© " + _vm._s(_vm.currentYear) + " "), _c('span', {
    staticClass: "mini-hidden"
  }, [_vm._v("Kiempunt - disclaimer")])])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4b69970","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/admin/components/sidebar/Sidebar.vue
// module id = msl+
// module chunks = 0 1